<template>
  <p>
    VIZBI 2016, the 7<sup>th</sup> international meeting on Visualizing Biological Data, was held
    9&ndash;11 March 2016 at the
    <a href="http://www.embl.de/">EMBL Advanced Training Centre</a>
    in Heidelberg, Germany.
  </p>
  <HeroImage hero-image="Hero.png" />
  <p>
    VIZBI 2016 featured
    <router-link to="People">21 invited talks</router-link>
    reviewing the state-of-the-art and challenges in visualizing data from genomes, transcripts,
    proteins, cells, organisms, and populations. Prior to the meeting (March 8), there were
    tutorials on several visualization tools.
  </p>
  <p>
    All participants had the opportunity to present a poster describing their work. Just before each
    poster session, participants were given 60 seconds and 2 slides to briefly introduce themselves
    and their poster to all VIZBI participants.
  </p>
  <p>
    As with previous meetings, VIZBI 2016 was an exciting event that helped raise the standard of
    data visualization in the life sciences. Highlights from the meeting are available on the VIZBI
    <router-link to="/blog">blog</router-link>,
    <router-link to="/Posters/2016">posters</router-link>,
    <router-link to="/photos/2016">photos</router-link>, and
    <router-link to="/videos">videos</router-link> pages.
  </p>
  <p>
    To receive updates about VIZBI, you can join the
    <a href="http://vizbi.org/blog/vizbi-mailing-list/">VIZBI mailing list</a>.
  </p>
</template>

<script setup>
import HeroImage from "@/components/HeroImage.vue";
</script>
